module.exports = __webpack_public_path__ + "static/media/BEECH.baa877d5.JPG";